import { Module } from 'vuex';
import { rootState } from '../state';
import { $fetch } from '@/api/fetch';
import REQ_URL from '@/consts/req-url';
import { SiteConf } from '@/types/site-conf';


const state = {
    catalogDownloadLink: ''
}

export const SiteConfStore: Module<typeof state, typeof rootState> = {
    state,
    mutations: {
        setSiteConfig(state, config) {
            state = Object.assign(state, config) 
        }
    },
    actions: {
        async setSiteConfig(c) {
            try {
                let data = await $fetch<SiteConf>(REQ_URL.GET_SITE_CONF)
                if (data.body) c.commit('setSiteConfig', data.body)
            } catch (error) {
            }
        }
    },
}